'use es6';

import { useMemo } from 'react';
import { pick } from 'underscore';
import { useQuery } from '../utils/DataFetchingClient';
import { GET_LESSON_AVAILABLE_LANGUAGES } from '../queries/lessonsQuery';

const useAvailableLanguages = (type = 'track', id) => {
  const {
    loading,
    data,
    error
  } = useQuery(type === 'lesson' ? GET_LESSON_AVAILABLE_LANGUAGES : null, {
    variables: pick({
      lessonId: type === 'lesson' && id
    }, Boolean)
  });
  const availableLanguagesData = useMemo(() => {
    if (!data) return [];
    return [...data].sort();
  }, [data]);
  return {
    availableLanguagesLoading: loading,
    availableLanguagesData,
    availableLanguagesError: error
  };
};

export default useAvailableLanguages;